
/* eslint-disable react/prop-types */
const ModalGeneric = ({ isVisible, onClose, children }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="relative bg-zinc-800 p-6 rounded-2xl shadow-xl w-full max-w-md">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-3xl font-bold"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalGeneric;
